export default __webpack_public_path__ + "static/media/Mondo.65c651cd.png";